import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Model from 'flarum/common/Model';
/**
 * A wiki article. `content` is the raw markdown source (used to pre-fill the
 * editor); `contentHtml` is the rendered output. The `can*` booleans are
 * server-computed per-actor gates the UI uses to decide which controls to show.
 */
export default class WikiArticle extends Model {
  constructor() {
    super(...arguments);
    _defineProperty(this, "title", Model.attribute('title'));
    _defineProperty(this, "slug", Model.attribute('slug'));
    _defineProperty(this, "position", Model.attribute('position'));
    _defineProperty(this, "isDraft", Model.attribute('isDraft'));
    _defineProperty(this, "faq", Model.attribute('faq'));
    _defineProperty(this, "content", Model.attribute('content'));
    _defineProperty(this, "contentHtml", Model.attribute('contentHtml'));
    _defineProperty(this, "excerpt", Model.attribute('excerpt'));
    _defineProperty(this, "revisionCount", Model.attribute('revisionCount'));
    _defineProperty(this, "canUpdate", Model.attribute('canUpdate'));
    _defineProperty(this, "canDelete", Model.attribute('canDelete'));
    _defineProperty(this, "isDeleted", Model.attribute('isDeleted'));
    _defineProperty(this, "createdAt", Model.attribute('createdAt', Model.transformDate));
    _defineProperty(this, "updatedAt", Model.attribute('updatedAt', Model.transformDate));
    _defineProperty(this, "lastEditedAt", Model.attribute('lastEditedAt', Model.transformDate));
    _defineProperty(this, "deletedAt", Model.attribute('deletedAt', Model.transformDate));
    _defineProperty(this, "user", Model.hasOne('user'));
    _defineProperty(this, "lastEditedBy", Model.hasOne('lastEditedBy'));
    _defineProperty(this, "category", Model.hasOne('category'));
  }
}
flarum.reg.add('linkrobins-wiki', 'common/models/WikiArticle', WikiArticle);